export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  tipoAcessoEvento: {
    value: [],
    options: [
      {name: 'Vendas', value: 'VENDA'},
      {name: 'Operações', value: 'OPERACAO'},
      {name: 'Cobranças', value: 'COBRANCA'}
    ],
    required: false,
    state: null
  },
  inative: {
    value: null,
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/eventtype/components/add/eventtype-form.js